import { render, staticRenderFns } from "./Treeselect4.vue?vue&type=template&id=195a9dac&"
import script from "./Treeselect4.vue?vue&type=script&lang=js&"
export * from "./Treeselect4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports